import {Component, OnInit, ViewChild} from '@angular/core';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {SnmpDestinationApiService} from '../../services/api/alarms/snmp-destination/snmp-destination-api.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {SnmpDestinationDialogComponent} from './snmp-destination-dialog/snmp-destination-dialog.component';
import _ from 'lodash';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {TrueFalsePipe} from '../../pipes/true-false/true-false.pipe';

@Component({
  selector: 'snmp-destination',
  templateUrl: './snmp-destination.component.html',
  styleUrls: ['./snmp-destination.component.scss']
})
export class SnmpDestinationComponent implements OnInit {

  items: any[];

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    { name: 'host', display: 'Host', selected: true, width: 200 },
    { name: 'port', display: 'Port', selected: true, width: 200 },
    { name: 'community', display: 'Community', selected: true, width: 200},
    { name: 'isAIM', display: 'AIM', selected: true, width: 100, transformer: TrueFalsePipe  },
    { name: 'deviceDescription', display: 'Device description', selected: true, width: 200},
    { name: 'isKeepAlive', display: 'keep-alive', selected: true, width: 100, transformer: TrueFalsePipe }
  ];

  search = '';
  filter;
  isUnauthorized: any;
  selection: any;

  constructor(private snmpApiService: SnmpDestinationApiService,
              private userPrivilege: UserPrivilegeService,
              private snackBarService: SnackBarService,
              public dialog: MatDialog, private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  addItem(): void {
    const dialogRef = this.dialog.open(SnmpDestinationDialogComponent, {
      width: '460px',
      data: {
        isEditMode: false
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.snmpApiService.addSnmpDestination(result).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.host}" successfully added`);
        this.refresh();
      });
    });
  }

  editItem(): void {
    const selectedItem = _.cloneDeep(this.selection);
    const dialogRef = this.dialog.open(SnmpDestinationDialogComponent, {
      width: '460px',
      data: {
        isEditMode: true,
        selectedItem
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.snmpApiService.editSnmpDestination(result.id, result).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.host}" successfully updated`);
        this.refresh();
      }).catch(err => {
        console.log(`Exception was thrown in edit snmp trap, reason: ${err}`);
      });
    });
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `Are you sure you want to delete "${this.selection.host}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.snmpApiService.deleteSnmpDestination(this.selection.id).then(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.host} successfully deleted`);
      });
    });
  }

  refresh(): void {
    this.loaderService.showMainContainer();
    this.snmpApiService.getSnmpDestination().subscribe(data => {
      this.items = data;
      this.loaderService.hideMainContainer();
    });
  }

  select(selection: any): void {
    this.selection = selection;
  }

  onFilter(filter: any): void {
    this.armTable.firstPage();
    this.filter = filter;
  }
}
